export default __webpack_public_path__ + "static/accessoires.range-6d02beb4c1a4899b153e985715bd5cd3.jpg";